import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { defineCdpRecsElement } from './element';
import '~/styles/main.scss';

// Kept for parity with the other exposed entries (Umbraco @Html.React relies on these
// globals); harmless for the standalone Web Component.
global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

// Register the portable <cdp-recs> custom element. defineCdpRecsElement declares the
// HTMLElement subclass lazily and no-ops server-side, so importing this module into the
// SSR bundle does NOT evaluate `class extends HTMLElement` (which would throw
// `ReferenceError: HTMLElement is not defined` and poison the SSR engine).
defineCdpRecsElement();
